<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, handleBlur, validate, errorMessage }">
      <!-- @vue-expect-error FIXME: value not assignable to type 'any[]' -->
      <ReorderList
        :modelValue="value"
        @update:modelValue="handleChange"
        @blur="handleBlur"
        @hide="validate"
        :class="{ 'p-invalid': errorMessage }"
        @onDragEnd="emit('onDragEnd', $event)"
        v-bind="$attrs"
      >
        <template v-if="label" #label>{{ label }}</template>
        <template v-if="errorMessage" #helperText>{{ errorMessage }}</template>
        <template #custom-action="{ element }">
          <slot name="custom-action" :element="element" />
        </template>
      </ReorderList>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { ReorderList } from './../../../core/misc';
import { FieldValidator } from './../field-validator';

const emit = defineEmits<{
  (e: 'onDragEnd', event: unknown): void;
}>();

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
});
</script>
